import gql from 'graphql-tag';

export default {
  getMyCampaigns: gql`
    fragment MessageToApprover_getMyCampaigns on Campaign {
      messageToApprover
    }
  `,
};
